import countries, { LocalizedCountryNames } from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";
import uk from "i18n-iso-countries/langs/uk.json";
import pl from "i18n-iso-countries/langs/pl.json";
import { useCallback, useEffect, useState } from "react";
import { SelectResponse } from "../../app/models/api/selectResponse";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../customDropdown/CustomDropdown";
import { getKeysFromObject } from "../../services/array/transformObject";

countries.registerLocale(en);
countries.registerLocale(uk);
countries.registerLocale(pl);

interface Props {
    label: string;
    defaultValue?: string;
    isDisable?: boolean;
    onSelect: (item: SelectResponse) => void;
}

const CountrySelector = ({ label, defaultValue, isDisable, onSelect }: Props) => {
    const { i18n } = useTranslation();
    const [countriesByLang, setCountriesByLang] = useState<LocalizedCountryNames<{ select: "official" }>>();

    const mapCountryCodeToSelectRespoponse = useCallback(
        (defaultValue?: string) => {
            if (defaultValue) {
                const countryName = countries.getName(defaultValue, i18n.language);
                if (countryName) {
                    return {
                        label: countryName,
                        value: defaultValue,
                    };
                }
            }
        },
        [i18n.language]
    );

    useEffect(() => {
        setCountriesByLang(countries.getNames(i18n.language));
    }, [i18n.language]);

    return (
        <CustomDropdown
            data={
                !countriesByLang
                    ? []
                    : getKeysFromObject(countriesByLang).map(
                          (key) =>
                              ({
                                  label: countriesByLang[key],
                                  value: countries.getAlpha2Code(countriesByLang[key], i18n.language),
                              }) as SelectResponse
                      )
            }
            label={label}
            defaultValue={mapCountryCodeToSelectRespoponse(defaultValue)}
            isCountryIcon={true}
            isDisable={isDisable}
            onSelect={onSelect}
        />
    );
};

export default CountrySelector;
